"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logos = void 0;
var logo_secondary_png_1 = __importDefault(require("./app/assets/auction_inc/logo_secondary.png"));
var logo_spelled_png_1 = __importDefault(require("./app/assets/auction_inc/logo-spelled.png"));
exports.logos = {
    dark: {
        img: logo_secondary_png_1.default,
        background: "bg-[#1A1A1A]",
    },
    light: {
        img: logo_spelled_png_1.default,
        background: "bg-transparent",
    },
};
